import { useMediaQuery } from "@mui/material";

export const GRAPH_HIDE_BREAKPOINT = 1250;

export const useHideGraphs = () => useMediaQuery(`(max-width:${GRAPH_HIDE_BREAKPOINT}px)`);
